/**
 * Starts a promise without waiting for it — the explicit replacement for the
 * `void` operator (Sonar S3735) that still satisfies `no-floating-promises`.
 *
 * It does NOT swallow the error: the rejection handler rethrows the same reason, so a
 * rejection becomes an `unhandledrejection` exactly as it did with
 * `void promise`, and whatever watches that global path (console, the New Relic
 * browser agent) still sees it.
 */
export function fireAndForget(promise: PromiseLike<unknown>): void {
  promise.then(undefined, (error: unknown) => {
    throw error;
  });
}
